// The marketing site (stashr.ai) and the Rails backend (mcp.stashr.ai) are different origins in
// production — window.location.origin on this page is always the marketing site, so it can never
// be used directly to build the connector URL. In local dev there's only one origin, so fall back
// to it there.
const MCP_HOST_BY_MARKETING_HOST: Record<string, string> = {
  'stashr.ai': 'mcp.stashr.ai',
  'www.stashr.ai': 'mcp.stashr.ai',
};

export function getMcpServerUrl(): string {
  if (typeof window === 'undefined') return '/api/mcp';

  const mcpHost = MCP_HOST_BY_MARKETING_HOST[window.location.hostname];

  // mcp.stashr.ai serves the endpoint at the short /mcp path (config/routes.rb constrains that
  // route to this host specifically); everywhere else — local dev, previewing this same page at
  // some other origin — falls back to /api/mcp, which has no such host constraint.
  return mcpHost ? `https://${mcpHost}/mcp` : `${window.location.origin}/api/mcp`;
}
